var _line, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-step-forward"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 6,
  x2: 6,
  y1: 4,
  y2: 20
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "10,4 20,12 10,20"
})));
export default SvgStepForward;